<div class="onboarding-form">
  <h1>Welcome back</h1>

  @if (form) {
    <form
      [formGroup]="form"
      [boFormOptions]="options"
      (ngSubmit)="onSubmit()"
      novalidate>
      <bo-non-field-errors />
      <app-form-field
        boFieldPath="username"
        [label]="'Email address'"
        [type]="InputType.email"
        [placeholder]="'Enter your email address'"></app-form-field>
      <app-password-field
        boFieldPath="password"
        [placeholder]="'Password'" />
      <p class="d-flex justify-content-end">
        <button
          type="button"
          id="loginForgotPasswordBtn"
          (click)="onForgotPassword()"
          class="btn btn-link p-0 link-secondary">
          Forgot password?
        </button>
      </p>
      <app-router-switch-btn
        id="loginToSignupBtn"
        title="Sign Up"
        urlLink="/sign-up/get-started"></app-router-switch-btn>
      <app-submit
        btnClass="btn-lg"
        btnID="loginSubmitBtn"
        [busy]="busy"
        label="Login"></app-submit>
    </form>
  } @else {
    <app-loader></app-loader>
  }
</div>
